import { render, staticRenderFns } from "./InflationCalculator.vue?vue&type=template&id=db6b9aa0&scoped=true&"
import script from "./InflationCalculator.vue?vue&type=script&lang=js&"
export * from "./InflationCalculator.vue?vue&type=script&lang=js&"
import style0 from "./InflationCalculator.vue?vue&type=style&index=0&id=db6b9aa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6b9aa0",
  null
  
)

export default component.exports